<template>
     <div v-if="loading">
            <div class="loader"></div>
    </div>
    <div v-else>
        <Table
                v-if="managers_role"
                title="Managers"
                :load_url="load_url"
                :search="search"
                :role="managers_role"
                :edit_url="edit_url"
                :disable_url="disable_url"
                :delete_url="delete_url">
        </Table>

        <Table
                v-if="staffs_role"
                title="Staff"
                :load_url="load_url"
                :search="search"
                :role="staffs_role"
                :edit_url="edit_url"
                :disable_url="disable_url"
                :delete_url="delete_url">
        </Table>
    </div>
</template>

<script>
	import RoleList from "./RoleList";
    import Collapsable from "../ListComponent/Collapsable";
    import Table from "../ListComponent/Table";
    import Loader from "../general_components/Loader";
	export default {
		name: "CompanyPeopleAndRoleListing",
		components: { Collapsable, RoleList, Table, Loader },
		props: [
            'roles',
            'load_url',
            'edit_url',
            'delete_url',
			'disable_url',
            'search',
            'loading'
        ],

        computed: {
			managers_role() {
                return this.getRole('manager');
            },

			staffs_role() {
                return this.getRole('staff');
            },

        },

        methods: {
            getRole(role_name) {
                if (role_name in this.roles) {
                    return this.roles[role_name];
                }
                return null;
            },
        },
	}
</script>
